import styled from "styled-components";

// main container
export const MainContent = styled.section``;
// heading container
export const HeadingContainer = styled.div`
  margin: 32px 0;
`;
// Heading
export const Heading = styled.h1`
  font-family: "Plus Jakarta Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  color: #18181b;
`;
// heading text
interface IHeadingText {
  show?: string;
}
export const HeadingText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  margin-top: 0.5rem;
  line-height: 15px;
  color: #78717a;
  display: ${(props: IHeadingText) => (props.show ? "block" : "none")};
`;

// Filter container
export const FilterContainer = styled.section`
  /* display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (min-width: 1440px) {
    display: flex;
    justify-content: space-between;
  } */

  @media screen and (min-width: 961px) {
    display: flex;
  }
  @media screen and (min-width: 436px) and (max-width: 960px) {
    display: flex;
    flex-wrap: wrap;
    /* justify-content: space-between; */
  }
  @media screen and (max-width: 435px) {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 20px;
    width: 100%;
    grid-template-areas:
      "searchBar"
      "filterContainer"
      "addUserBtn";
  }
`;

// search container
interface SearchInputProps {
  half?: boolean;
}
export const SearchBarContainer = styled.div<SearchInputProps>`
  // position: relative;

  align-items: center;
  display: flex;
  /* width: ${(props) => (props.half ? "50%" : "100%")}; */
  margin-right: 20px;
  width: 100%;
  border-radius: 3px;
  padding-left: 10px;
  /* outline: none; */
  /* on click make width larger */
  transition: width 0.4s ease-in-out;
  /* @media screen and (min-width: 961px) {
    width: 170px;
    &:focus-within {
      width: 80%;
      border: 1px solid var(--border_color);
    }
  } */

  /* @media screen and (max-width: 1024px) and (min-width: 769px) {
    grid-area: 1/1/2/3;
  } */
  /* @media screen and (max-width: 768px) {
    grid-area: searchBar;
    margin-right: 0;
    margin: 10px auto;
    width: 100%;
    border: 1px solid var(--border_color);
  } */
  @media only screen and (min-width: 436px) and (max-width: 960px) {
    border: 1px solid;
    border: 1px solid var(--border_color);
    margin-bottom: 20px;
  }
  @media screen and (max-width: 435px) {
    border: 1px solid var(--border_color);
    margin-bottom: 20px;
  }
`;

export const SearchIcon = styled.img`
  position: absolute;
  left: 0.9375rem;
  top: 17px;
  width: 1.125rem;
`;

export const SearchBar = styled.input`
  width: 100%;
  height: 40px;
  /* text-indent: 2.8125rem; */

  text-indent: 5px;

  border: none;
  outline: none;
  background: var(--input_background);
  background-color: #fff;
  border-radius: var(--btn_border_radius);
  &::placeholder {
    /* color: var(--input_text_color); */
  }
  &::-webkit-search-decoration,
  &::-webkit-search-results-button,
  &::-webkit-search-results-decoration {
    display: none;
  }
  &:disabled {
    cursor: not-allowed;
  }
`;
// =====================
// roles and facilities container select container
export const RolesAndFacilitiesContainer = styled.div`
  /* grid-area: 1/2/2/3; */
  /* display: flex;
  align-items: center;
  width: 100%; */
  @media screen and (min-width: 961px) {
    /* position: absolute;
    top: 0;
    height: 100px;
    width: 1200px;
    display: flex;
    overflow-x: scroll;
    z-index: 99;
    background-color: white; */
    display: flex;
    align-items: center;
  }

  /* @media screen and (max-width: 1024px) and (min-width: 769px) {
    grid-area: 2/1/3/4;
    width: 100%;
  } */
  /* @media screen and (max-width: 768px) {
    grid-area: filterContainer;
    justify-content: space-between;
    justify-content: flex-start;
    display: grid;
    grid-template-areas: "selectContainer clearFilterBtn";
    margin: 10px auto;
  }
  @media screen and (max-width: 320px) {
    display: flex;
    flex-direction: column;
  } */
`;
export const MainSelectContainer = styled.div`
  @media screen and (min-width: 961px) {
    grid-area: selectContainer;

    display: flex;
    width: 100%;
    /* margin-bottom: 15px; */
  }
  @media screen and (min-width: 436px) and (max-width: 960px) {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
  }
  @media screen and (max-width: 435px) {
    width: 100%;
    display: grid !important;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    margin-bottom: 20px;
  }
  @media screen and (max-width: 320px) {
    flex-direction: column;
    margin-bottom: 10px;
  }
`;
interface SelectContainerProps {
  addMargin?: boolean;
  role?: string;
}
export const SelectContainer = styled.div<SelectContainerProps>`
  @media screen and (min-width: 1024px) {
    margin-right: 20px;
    width: 200px;
    z-index: 5;
  }

  @media screen and (max-width: 820px) {
    margin-right: 0;
    /* width: 100%; */
  }
  @media screen and (max-width: 321px) {
    margin-right: ${(props) => (props.role === "role" ? "15px" : "0")};
  }
`;
interface SelectProps {
  where?: string;
}
export const Select = styled.select<SelectProps>`
  /* width: 200px; */
  /* @media screen and (min-width: 1024px) {
    width: ${(props) => (props.where === "/user/users" ? "200px" : "100%")};
  } */
  @media screen and (min-width: 961px) {
    /* width: 250px; */
    /* border: 1px solid; */
  }

  width: 100%;

  height: 40px;
  padding: 5px;
  border: 1px solid rgba(58, 53, 65, 0.23);
  color: var(--text_purple);
  border-radius: 4px;
  margin-right: ${(props) => (props.role === "role" ? "15px" : "0")};
  display: grid;
  &&:after {
    content: "▼";
    /* content: ""; */
    /* width: 0.8em; */
    height: 0.5em;
    background-color: gold;
    clip-path: polygon(100%, 0%, 0 0%, 50% 100%);
  }
  z-index: 199;
`;
// facilities container

export const ClearFilterButtonContainer = styled.div`
  /* margin: 10px; */
  /* display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (min-width: 1440px) {
    width: 100%;
  }
  @media screen and (width: 768px) {
    width: 100px;
    align-items: flex-end;
  } */
  /* width: 50%; */
  @media screen and (min-width: 961px) {
    display: flex;
    /* border: 1px solid; */
    align-items: center;
  }

  @media screen and (min-width: 436px) and (max-width: 960px) {
    margin-bottom: 20px;
  }
  @media screen and (min-width: 320px) and (max-width: 435px) {
    margin-bottom: 20px;
  }
`;
export const ClearFilterButton = styled.button`
  border: none;
  /* border: 1px solid gold; */
  color: #745082;
  font-size: 0.8em;
  background-color: #fff;
  cursor: pointer;
  width: 80px;
  @media screen and (min-width: 961px) {
    border: 1px solid var(--input_background);
  }
  border-radius: 4px;
  @media only screen and (max-width: 768px) {
    font-size: 13px;

    display: flex;
    justify-content: flex-end;
  }
`;
// end of roles and facilities container select container
// ==========

export const AddIncidentButtonContainer = styled.div`
  /* border: 1px solid green; */
`;
export const AddIcon = styled.img`
  display: inline-block;
  /* margin-right: 0.4rem; */
  @media screen and (max-width: 768px) {
    margin-right: 0.4rem;
  }
`;
export const AddIncidentButton = styled.button.attrs({
  // className: "px-7",
})<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 200px;
  width: 100%;
  border: none;
  background: var(--main-purple-light);
  border-radius: var(--btn_border_radius);
  color: #fff;
  // transition: all 0.3s ease-in-out;
  :hover {
    background: var(--main_purple_light_shade);
    color: #fff;
    border: 1px solid var(--main-purple-light);
  }
  &:disabled {
    opacity: 0.5;
  }

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
  cursor: pointer;
`;
// add user button
export const AddUserButtonContainer = styled.div`
  @media screen and (min-width: 961px) {
    width: 50%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  @media screen and (min-width: 436px) and (max-width: 960px) {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
`;
export const AddUserButton = styled(AddIncidentButton)<{ disabled?: boolean }>`
  height: 50px;
  @media screen and (min-width: 961px) {
    width: 180px;
  }
  @media screen and (min-width: 436px) and (max-width: 960px) {
  }
`;
// end of add user button
// =============
// table container
export const TableContainer = styled.div`
  margin: 32px 0;
`;
// end of table container
// =============
// general pagination container
export const GeneralPaginationContainer = styled.div`
  margin: 4rem 0;
  @media screen and (min-width: 769px) {
    display: flex;
    justify-content: space-between;
  }
`;
export const PaginatedItemsPerPageSelectContainer = styled.div``;
export const SelectItemsPerPageContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 5px auto;
`;
export const SelectItemPerPage = styled.select`
  /* padding: 4px; */
  // min-width: 50px;
  border: none;
  background: rgba(94, 99, 102, 0.08);
  border-radius: var(--btn_border_radius);
  margin-right: 16px;
  color: #8b8d97;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  height: 30px;
`;
export const ItemCountTextContainer = styled.div`
  margin-right: 36px;
`;
export const ItemPerPageCountText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 15px;
  color: #a6a8b1;
`;
export const ItemRangeContainer = styled.div``;
export const ItemRangeText = styled(ItemPerPageCountText)`
  color: #78717a;
  font-size: 1.1rem;
`;
export const From = styled.span``;
export const To = styled.span`
  color: var(--pagina_text_color);
  margin: 0 5px;
  font-size: 1.1rem;
  /* height: 30px; */
`;
export const TotalItemsPerCurrentPage = styled.span``;

// =============

// user details popup
export const UserDetailsPopupContainer = styled.div``;
export const UserDetailList = styled.ul``;
export const UserDetail = styled.li``;
